import React from 'react';
import { FunctionComponent } from 'react';

import { MenuLabels } from './MenuLabels';
import { TaskLabels } from './TaskLabels';

import { ILabelsProps } from './types';

export const Labels: FunctionComponent<ILabelsProps> = ({ menu, taskId }) => {
  return menu ? <MenuLabels taskId={taskId} /> : <TaskLabels taskId={taskId} />;
};
